// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewCommentsList.test.tsx
import { Badge } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import {
  alwaysOnTagLabelKey,
  type CommentWithOptionalTags,
  reviewCommentAlwaysOnTags,
  reviewCommentTagLabelKey,
  reviewCommentTags,
} from "./reviewCommentTags";

type CommentTagBadgesProps = {
  comment: CommentWithOptionalTags;
  commentId: string;
};

export function CommentTagBadges({
  comment,
  commentId,
}: CommentTagBadgesProps) {
  const { t } = useTranslation("ui");
  const tags = reviewCommentTags(comment);
  const alwaysOn = reviewCommentAlwaysOnTags(comment);
  if (tags.length === 0 && alwaysOn.length === 0) return null;

  return (
    <>
      {alwaysOn.map((tag) => (
        <Badge
          key={tag}
          size="1"
          variant="soft"
          color="gray"
          data-testid={`ask-v2-review-comment-tag-${commentId}-${tag}`}
          title={t(`reviewPreflight.alwaysOn.${tag}.description`)}
        >
          {t(alwaysOnTagLabelKey(tag))}
        </Badge>
      ))}
      {tags.map((tag) => (
        <Badge
          key={tag}
          size="1"
          variant="soft"
          color="gray"
          data-testid={`ask-v2-review-comment-tag-${commentId}-${tag}`}
        >
          {t(reviewCommentTagLabelKey(tag))}
        </Badge>
      ))}
    </>
  );
}
